<!-- src/components/MessageSources.vue -->
<template>
  <div class="mt-4 pt-3 border-t border-gray-100">
    <button
      @click="showSources = !showSources"
      class="text-sm text-gray-600 hover:text-gray-800 flex items-center gap-2 transition-colors font-medium bg-gray-50/50 px-3 py-1.5 rounded-lg w-full"
    >
      <span class="flex items-center gap-2">
        📚 Použité zdroje
        <span class="bg-gray-200/50 px-2 py-0.5 rounded-full text-xs">
          {{ sources.length }}
        </span>
      </span>
      <svg
        class="w-4 h-4 transition-transform ml-auto"
        :class="{ 'rotate-180': showSources }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>

    <Transition name="slide-fade">
      <div v-if="showSources" class="mt-3 space-y-1.5">
        <SourceItem
          v-for="(source, idx) in sources"
          :key="idx"
          :source="source"
          :index="idx"
        />
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from "vue";
import SourceItem from "./SourceItem.vue";

defineProps({
  sources: {
    type: Array,
    required: true,
  },
});

const showSources = ref(false);
</script>

<style scoped>
/* Transition animace pro sources */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
